/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAPITokenValueTypeFromJSON, ApiAPITokenValueTypeToJSON, } from './ApiAPITokenValueType';
export function ApiAPITokenValueResponseFromJSON(json) {
    return ApiAPITokenValueResponseFromJSONTyped(json, false);
}
export function ApiAPITokenValueResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : ApiAPITokenValueTypeFromJSON(json['type']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiAPITokenValueResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': ApiAPITokenValueTypeToJSON(value.type),
        'value': value.value,
    };
}
